import React from 'react';
import ContactForm from './ContactForm';
import GoogleMapStyle from './GoogleMapStyle';
import { FiHeadphones, FiMail, FiMapPin } from 'react-icons/fi';

const contentFr = {
  byPhone: 'Par téléphone',
  byEmail: 'Par email',
  inPerson: 'En personne'
};

const contentEng = {
  byPhone: 'By phone',
  byEmail: 'By email',
  inPerson: 'In person'
};

const ContactOne = () => {
  const lang = window.location.href.includes('/fr') ? 'fr' : 'eng';

  const content = lang === 'fr' ? contentFr : contentEng;

  return (
    <>
      <div className="row row--15">
        <div className="col-lg-12">
          <div className="rn-contact-address mt_dec--30">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiHeadphones />
                  </div>
                  <div className="inner">
                    <h4 className="title">{content.byPhone}</h4>
                    <p>
                      <a href="tel:+971585047791">+971 58 504 7791</a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiMail />
                  </div>
                  <div className="inner">
                    <h4 className="title">{content.byEmail}</h4>
                    <p>
                      <a href="mailto:w.finance@proton.me">
                        w.finance@proton.me
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiMapPin />
                  </div>
                  <div className="inner">
                    <h4 className="title">{content.inPerson}</h4>
                    <p>
                      <a
                        href="https://www.google.com/maps/place/B2+-+Dubai+Digital+Park+-+Dubai+Silicon+Oasis/@25.1199627,55.3769921,858m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3e5f65eef085d9cf:0x78bbf81f0c92784f!8m2!3d25.1199627!4d55.3795724!16s%2Fg%2F11sp94k9p8?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Office A2, Dubai Digital Park, Dubai Silicon Oasis,
                        Dubai, Emirats Arabes Unis
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt--40 row--15">
        <div className="col-lg-7">
          <ContactForm formStyle="contact-form-1" lang={lang} />
        </div>
        <div className="col-lg-5 mt_md--30 mt_sm--30">
          <GoogleMapStyle />
        </div>
      </div>
    </>
  );
};
export default ContactOne;
